import { Icon } from '@iconify/react';
import { Button, Card } from '@nextui-org/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ChangePasswordSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-md p-6 text-center">
        <div className="mb-6 flex justify-center">
          <div className="rounded-full bg-success/10 p-3">
            <Icon icon="mdi:check-circle" className="h-12 w-12 text-success" />
          </div>
        </div>

        <h2 className="mb-2 text-xl font-bold">
          Password Changed Successfully
        </h2>
        <p className="mb-6 text-gray-500">
          Your password has been updated. Please log in again with your new
          password to continue.
        </p>

        <Button
          color="primary"
          className="w-full"
          onClick={() => navigate('/login')}
          startContent={<Icon icon="mdi:login" />}
        >
          Log In
        </Button>
      </Card>
    </div>
  );
};

export default ChangePasswordSuccess;
